import React, { useEffect, useState } from 'react';
import './styles.css';
import ToggleSwitch from './ToggleSwitch';
import { CheckIcon } from './icons';
import { getPlans } from '@custom/rtk-apis/Setting/plans/getPlans';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@custom/store/store';
import { useTheme } from "../../../ui/src/contextProviders"
import createStripePortalSession from '@custom/rtk-apis/payement-gateway/createStripeSession';
import { _purchase_type, _roleType } from '@custom/Utils/constants/appConstants';
import { getCaseCredits } from '@custom/rtk-apis/Setting/creditForCaseToCase/getCaseCredits';
import { ConfirmationPopup } from '@ohif/ui';
import { HospitalDetails } from '@custom/Utils/constants/interfaces';
import { convertKBtoGB } from '@custom/Utils/utils';
import CheckoutModal from '../CheckoutModal/CheckoutModal';

interface Plan {
  name: string;
  monthlyUsers: string;
  yearlyUsers: string;
  monthlyCloudStorage: string;
  yearlyCloudStorage: string;
  monthlySpeechToText?: boolean;
  monthlyAiServices?: boolean;
  yearlySpeechToText?: boolean;
  yearlyAiServices?: boolean;
  monthlyPrice: number;
  yearlyPrice: number;
  customMonthlyFeatures: string;
  customYearlyFeatures: string;
  plan_code: string;
  isPublished: boolean;
}

interface PricingCardProps {
  setLoading: (loading: boolean) => void;
  loading: boolean,
  planDetails?: HospitalDetails;
  showModal?: boolean;
  expiryDate?: string;
}

const PricingCard: React.FC<PricingCardProps> = ({setLoading,loading,planDetails,showModal,expiryDate}) => {
  const dispatch = useDispatch<AppDispatch>();
  const role = localStorage.getItem('role') || sessionStorage.getItem('role');
  const plansData = useSelector((state: RootState) => state?.getPlansResponse);
  const [isMonthly, setIsMonthly] = useState(true);
  const [isOpen, setIsOpen] = useState(showModal || false);
  const [plans, setPlans] = useState<Plan[]>([]);
  const [caseCredits, setCaseCredits] = useState<any[]>([]);
  const [isPopupOpen,setIsPopupOpen] = useState(false);
  const [currentPurchasedPlan, setCurrentPurchasedPlan] = useState<string>('');
  const [selectedPlan, setSelectedPlan] = useState<Plan | null>(null);
  const [addons, setAddons] = useState({
  extraStorage: false,
  addonsPurchased: false,
  });
  const { isDarkMode } = useTheme();
  const [isCheckout, setIscheckout] = useState(false);

  const getCaseCreditsData = async () => {
    const response = await dispatch(getCaseCredits()).unwrap();
    setCaseCredits(response?.caseCredits);
  }

  const handleCancel = () =>{
    setIsPopupOpen(false);
  }

  const handleConfirm = () => {
    setIsPopupOpen(false);

    const hospital_code = localStorage.getItem('hospitalCode') || sessionStorage.getItem('hospitalCode');
    const payload = {
    "product_name": (addons.addonsPurchased || addons.extraStorage) ? `${selectedPlan.name} with Addons` : selectedPlan.name,
    // @ts-ignore
    "product_amount": isMonthly ? parseInt(selectedPlan.monthlyPrice) : parseInt(selectedPlan.yearlyPrice),
    "purchase_type": _purchase_type.SUBSCRIPTION_WITH_ADDONS,
    "hospital_code": hospital_code,
    'plan_code': selectedPlan.plan_code,
    'plan_type': isMonthly ? 'monthly' : 'yearly',
    'servicesEnabled': planDetails?.addOnsPurchased || [],
    'previousAddonsIncluded': addons
    }

    setLoading(true);

    dispatch(createStripePortalSession(payload)).catch((error) => {
      console.error('Error creating Stripe portal session:', error);
      setLoading(false);
    });
  }


  useEffect(() => {
    // @ts-ignore
    if(planDetails?.subscriptionDetail?.plan_code){
      console.log("Current Purchased Plan",planDetails?.subscriptionDetail)
      // @ts-ignore
      setCurrentPurchasedPlan(planDetails?.subscriptionDetail?.plan_code);
    }
    getCaseCreditsData();
  }, []);

  useEffect(() => {
    dispatch(getPlans());
  }, [dispatch]);

  useEffect(() => {
    if (plansData?.success) {
      // @ts-ignore
      const mappedPlans = plansData?.plans?.data?.map((plan: any) => ({
        name: plan.name,
        monthlyUsers: plan.monthly?.users,
        yearlyUsers: plan.yearly?.users,
        monthlyCloudStorage: plan.monthly?.cloudStorage,
        yearlyCloudStorage: plan.yearly?.cloudStorage,
        monthlySpeechToText: plan.monthly?.speechToText,
        monthlyAiServices: plan.monthly?.aiServices,
        yearlySpeechToText: plan.yearly?.speechToText,
        yearlyAiServices: plan.yearly?.aiServices,
        monthlyPrice: plan.monthly?.planPrice,
        yearlyPrice: plan.yearly?.planPrice,
        customMonthlyFeatures: plan.monthly?.customFeatures || [],
        customYearlyFeatures: plan.yearly?.customFeatures || [],
        plan_code: plan.plan_code,
        isPublished: plan?.isPublished
      })) || [];
      setPlans(mappedPlans);
    }
  }, [plansData?.success]);

  const togglePricingPeriod = () => {
    setIsMonthly(!isMonthly);
  };

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const handleSelectPlan = (discount : number, couponCode: string, couponStatus: string) => {

    const hospital_code = localStorage.getItem('hospitalCode') || sessionStorage.getItem('hospitalCode');
    const payload = {
    "product_name": selectedPlan.name,
    // @ts-ignore
    "product_amount": isMonthly ? parseInt(selectedPlan.monthlyPrice) - discount : parseInt(selectedPlan.yearlyPrice) - discount,
    "purchase_type": _purchase_type.SUBSCRIPTION,
    "hospital_code": hospital_code,
    'plan_code': selectedPlan.plan_code,
    'plan_type': isMonthly ? 'monthly' : 'yearly',
    'giftCardCode': couponStatus == 'valid' ? couponCode : '',
    }

    setLoading(true);

    dispatch(createStripePortalSession(payload)).catch((error) => {
      console.error('Error creating Stripe portal session:', error);
      setLoading(false);
    });
  };

  const openCheckout = (plan:Plan) => {
    setSelectedPlan(plan)
    setIscheckout(true);
  }

  return (
    <>
      <div className={`pricing-modal-overlay ${isOpen ? 'open' : ''}`} onClick={closeModal}>
        <div
          className={`pricing-modal-content ${isDarkMode ? 'dark-mode' : ''}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className={`pricing-modal-header ${isDarkMode ? 'dark-mode' : ''}`}>
            <h2 className={isDarkMode ? 'text-white' : ''}>Choose Your Plan</h2>
            <button className={`close-button ${isDarkMode ? 'dark-mode' : ''}`} onClick={closeModal}>×</button>
          </div>

          <div className="toggle-container">
            <ToggleSwitch
              isMonthly={isMonthly}
              onToggle={togglePricingPeriod}
            />
          </div>

          <div className="hospital-pricing-cards-container">
            {plans.map((plan, index) => {
              if (!plan.isPublished && role !== _roleType.superAdmin) return null;
              return <div
                className={`pricing-card ${plan.name === 'Professional' ? 'popular' : ''} ${isDarkMode ? 'dark-mode' : ''}`}
                key={index}
              >
                <div className={`pricing-card-header ${isDarkMode ? 'dark-mode' : ''}`}>
                  {/* {plan.name === 'Professional' && <div className="popular-badge">Most Popular</div>} */}
                  <h3 className={isDarkMode ? 'text-white' : ''}>{plan.name}</h3>
                  {isMonthly ? (
                    <p className="price">₹{plan.monthlyPrice}</p>
                  ) : (
                    <p className="price">₹{plan.yearlyPrice}</p>
                  )}
                </div>

                <div className={`pricing-card-body ${isDarkMode ? 'dark-mode' : ''}`}>
                  <ul className="features-list">
                    <li className="feature-item">
                      <CheckIcon />
                      <span className={isDarkMode ? 'text-white' : ''}>
                        {isMonthly ? plan.monthlyUsers : plan.yearlyUsers} Users
                      </span>
                    </li>
                    {isMonthly ? plan.monthlySpeechToText && (
                      <li className="feature-item">
                        <CheckIcon />
                        <span className={isDarkMode ? 'text-white' : ''}>Speech to Text</span>
                      </li>
                    ) : plan.yearlySpeechToText && (
                      <li className="feature-item">
                        <CheckIcon />
                        <span className={isDarkMode ? 'text-white' : ''}>Speech to Text</span>
                      </li>
                    )}
                    {isMonthly ? plan.monthlyAiServices && (
                      <li className="feature-item">
                        <CheckIcon />
                        <span className={isDarkMode ? 'text-white' : ''}>AI Services</span>
                      </li>
                    ) : plan.yearlyAiServices && (
                      <li className="feature-item">
                        <CheckIcon />
                        <span className={isDarkMode ? 'text-white' : ''}>AI Services</span>
                      </li>
                    )}
                    <li className="feature-item">
                      <CheckIcon />
                      <span className={isDarkMode ? 'text-white' : ''}>
                        {isMonthly ? plan.monthlyCloudStorage : plan.yearlyCloudStorage} GB Cloud Storage
                      </span>
                    </li>
                    {isMonthly ? (
                      Array.isArray(plan.customMonthlyFeatures) && plan.customMonthlyFeatures.length > 0 && (
                        plan.customMonthlyFeatures.map((feature, index) => (
                          <li key={index} className="feature-item">
                            <CheckIcon />
                            <span className={isDarkMode ? 'text-white' : ''}>{feature}</span>
                          </li>
                        ))
                      )
                    ) : (
                      Array.isArray(plan.customYearlyFeatures) && plan.customYearlyFeatures.length > 0 && (
                        plan.customYearlyFeatures.map((feature, index) => (
                          <li key={index} className="feature-item">
                            <CheckIcon />
                            <span className={isDarkMode ? 'text-white' : ''}>{feature}</span>
                          </li>
                        ))
                      )
                    )}
                  </ul>
                </div>

                <div className={`pricing-card-footer ${isDarkMode ? 'dark-mode' : ''}`}>
                  <button style={{borderRadius: "50px"}} disabled={loading || currentPurchasedPlan === plan.plan_code} className="select-plan-btn" onClick={() => openCheckout(plan)}>
                    {currentPurchasedPlan === plan.plan_code ? 'Current Plan'  : `Select Plan`}
                  </button>
                  {/* <button disabled={loading || currentPurchasedPlan === plan.plan_code} className="select-plan-btn" onClick={() => handleSelectPlan(plan)}>
                    {currentPurchasedPlan === plan.plan_code ? 'Current Plan'  : `Select Plan`}
                  </button> */}
                </div>
              </div>
            })}
           <div
             className={`pricing-card ${isDarkMode ? 'dark-mode' : ''} flex flex-col rounded-lg shadow-md w-full max-w-md mx-auto`}
           >
             <div className="flex-1 h-auto">
               <h3
                 className="font-bold text-2xl tracking-wide text-center"
                 style={{
                   backgroundColor: isDarkMode ? "#1f2937" : "#f8f9fa",
                   padding: "0.5rem 2rem 2.25rem",
                   color: isDarkMode ? "#fff" : "#000",
                 }}
               >
                 Case to Case Plan
               </h3>

               <p
                 className={`text-center mt-4 ${
                   isDarkMode ? 'text-white' : 'text-gray-600'
                 }`}
               >
                 Please contact us for more details.
               </p>
             </div>

             <div
               className={`pricing-card-footer mt-6 flex justify-center ${
                 isDarkMode ? 'dark-mode' : ''
               }`}
             >
               <button
                 onClick={() => {
                   if (!loading) {
                     window.open("https://seven-hills2.odoo.com/contactus", "_blank");
                   }
                 }}
                 disabled={loading}
                 className="select-plan-btn bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition duration-200 disabled:opacity-50"
                 style={{borderRadius: "50px"}}
               >
                 Contact Us
               </button>
             </div>
            </div>

          </div>
        </div>
      </div>

      <button className="btn btn__primary upgrade-plan-btn" onClick={openModal}>
        Upgrade Plan
      </button>
    <ConfirmationPopup
      isOpen={isPopupOpen}
      title="Plan Upgrade"
      message={`Do you want to include these ?`}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      textField={
        <div className="flex flex-col gap-2 pt-3">
          {planDetails?.addOnsPurchased?.length > 0 && <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={addons.addonsPurchased}
              onChange={(e) =>
                setAddons((prev) => ({ ...prev, addonsPurchased: e.target.checked }))
              }
            />
            <span>Addons purchased</span>
          </label>}
        </div>
      }
    />

    {isCheckout &&
      <CheckoutModal
       plan={selectedPlan}
       productName={selectedPlan?.name || ''}
       price={isMonthly ? selectedPlan?.monthlyPrice : selectedPlan?.yearlyPrice}
       onClose={()=>setIscheckout(false)}
       handleSelectPlan={handleSelectPlan}
      />
    }
    </>
  );
};

export default PricingCard;
